module.exports = __webpack_public_path__ + "static/img/loginTitle.c63e6114.png";